import { apiSlice } from "../api/apiSlice";
import io from "socket.io-client";
export const projectsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: (teams) =>{
              let string ='';
              if(teams?.length === 1 ){
                string=`teamId=${teams && teams[0]}`
              }
              if(teams?.length !== 1 && teams?.length >0 ){
                // string = ''
                teams.map((item)=>{
                    string +='teamId='+item+'&'
                })
              }
              return `/projects?${string}&_sort=created&_order=desc`
            },
            providesTags: ['Projects'],
        }),


        addProject: builder.mutation({
            query: ({id,data}) => ({
                url: "/projects",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Projects"],
        }),

        updateProject: builder.mutation({
            query: ({id,data,teams}) => ({
                url: `/projects/${id}`,
                method: "PATCH",
                body: data,
            }),
            // invalidatesTags: ["Projects"],
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                 // optimistic cache update start
                const patchResult = dispatch(
                    apiSlice.util.updateQueryData(
                        "getProjects",
                        arg.teams,
                        (draft) => {
                            const draftProject= draft.find(
                                (c) => c.id == arg.id
                            );
                            draftProject.stage=arg.data.stage;
                        }
                    )
                );
                try {
                    const conversation = await queryFulfilled;
                    if (conversation?.data?.id) {
                        //nothing to do
                    }
                } catch (err) {
                    patchResult.undo();
                }
                // optimistic cache update end
            }
        }),

        deleteProject: builder.mutation({
            query: (id) => ({
                url: `/projects/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Projects"],
        }),
    }),
});

export const { useGetProjectsQuery, useAddProjectMutation,useDeleteProjectMutation,useUpdateProjectMutation  } = projectsApi;
